import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	routes: [],
};

export const RouterReducer = createSlice({
	name: "routerReducer",
	initialState,
	reducers: {
		setRoutes: (state, action) => {
			state.routes = action.payload;
		},

		clearRoutes: () => {
			return initialState;
		},
	},
});

// Action creators are generated for each case reducer function
export const { clearRoutes, setRoutes } = RouterReducer.actions;

export default RouterReducer.reducer;
